import Vue from 'vue'
import Vuex from 'vuex'
import Api from './api'
import { apiUrl } from "../../config"

Vue.use(Vuex)

const initDebugMode = (sessionStorage.getItem('debugMode') === 'true')
const initSelectedPartnerID = sessionStorage.getItem('selectedPartnerID')
const initSelectedAccountID = sessionStorage.getItem('selectedAccountID')
const initSelectedProfileID = sessionStorage.getItem('selectedProfileID')

function initState(state) {
  state.partner = {}
  state.partners = []
  state.account = {}
  state.accounts = []
  state.settings = {}
  state.subscriptions = []
  initStatePartner(state)
}

function initStatePartner(state) {
  state.partner = {}
  state.accounts = []
  initStateAccount(state)
}

function initStateAccount(state) {
  state.account = {}
  state.profiles = []
  initStateProfile(state)
}

function initStateProfile(state) {
  state.profile = {}
  // Exposure
  state.exposure = {}
  // Remediation
  state.remediation = {}
  state.remediationLog = []
  // Alerts
  state.alerts = []
  state.alertsTotal = 0
  state.alertsStats = {}
  // Keywords
  state.keywords = []
  state.keywordsFilter = {
    'type': '',
    'value': '',
    'sortAttr': 'total_alerts',
    'sortReverse': false
  }
}

export default new Vuex.Store({
  state: {
    // Flags
    adminMode: false,
    partnerMode: false,
    accountMode: false,
    debugMode: initDebugMode,
    exporting: false,
    // Api
    apiAuth: null,
    // Partner
    partner: {},
    partners: [],
    // Account
    account: {},
    accounts: [],
    // Profile
    profile: {},
    profiles: [],
    // Settings
    settings: {},
    // Exposure
    exposure: {},
    // Remediation
    remediation: {},
    remediationLog: [],
    subscriptions: [],
    // Alerts
    alerts: [],
    alertsTotal: 0,//This is for filtered alerts above
    alertsLoading: false,
    alertsStats: {},
    // Keywords
    keywords: [],
    keywordsFilter: {
      'type': '',
      'value': '',
      'sortAttr': 'total_alerts',
      'sortReverse': false
    },
    userInfo: {}
  },


  /*
  Getters
  */
  getters: {
    getPartnerById: (state) => (id) => {
      return state.partners.find(partner => partner.id === id)
    },
    getAccountById: (state) => (id) => {
      return state.accounts.find(account => account.id === id)
    },
    getProfileById: (state) => (id) => {
      return (state && state.profiles) ? state.profiles.find(profile => profile.id === id) : {}
    },
    getDefaultProfile: (state) => () => {
      return (state && state.profiles) ? state.profiles.find(profile => profile.default) : {}
    },
    getAlertById: (state) => (id) => {
      return state.alerts.find(alert => alert.id === id)
    }
  },


  /*
  Mutations
  */
  mutations: {
    initState (state) {
      // console.log('initState')
      initState(state)
    },
    initStatePartner (state) {
      // console.log('initStatePartner')
      initStatePartner(state)
    },
    initStateAccount (state) {
      // console.log('initStateAccount')
      initStateAccount(state)
    },
    initStateProfile (state) {
      // console.log('initStateProfile')
      initStateProfile(state)
    },
    setAdminMode (state) {
      state.adminMode = true
      state.partnerMode = false
      state.accountMode = false
    },
    setPartnerMode (state) {
      state.adminMode = false
      state.partnerMode = true
      state.accountMode = false
    },
    setAccountMode (state) {
      state.adminMode = false
      state.partnerMode = false
      state.accountMode = true
    },
    setDebugMode (state, debugMode) {
      sessionStorage.setItem('debugMode', debugMode)
      state.debugMode = debugMode
    },
    setExporting (state, exporting) {
      state.exporting = exporting
    },
    setAuthAccessToken (state, accessToken) {      
      state.apiAuth = new Api(apiUrl, accessToken)
    },
    // Partner
    setPartner (state, partner) {
      // console.log('setPartner', partner)
      sessionStorage.setItem('selectedPartnerID', partner.id)
      state.apiAuth.partner_id = partner.id
      state.partner = partner
    },
    addPartner (state, partner) {
      // console.log('addPartner', partner)
      state.partners.push(partner)
    },
   /* removePartner (state, partner) {
      // console.log('removeAccount', account)
      var idx = state.partners.findIndex(p => p.id === partner.id)
      if (idx >= 0) state.partners.splice(idx, 1)
    },*/
    // Account
    setAccounts (state, accounts) {
      // console.log('setAccounts', accounts)
      state.accounts = accounts
    },
    setAccount (state, account) {
      // console.log('setAccount', account)
      sessionStorage.setItem('selectedAccountID', account.id)
      state.apiAuth.account_id = account.id
      state.account = account
    },
    addAccount (state, account) {
      // console.log('addAccount', account)
      state.accounts.push(account)
    },
    removeAccount (state, account) {
      // console.log('removeAccount', account)
      var idx = state.accounts.findIndex(a => a.id === account.id)
      if (idx >= 0) state.accounts.splice(idx, 1)
    },
    // Settings
    setSettings (state, settings) {
      state.settings = settings
    },
    setPartnerSettings (state, settings) {
      state.partner.settings = settings
    },
    setAccountSettings (state, settings) {
      state.account.settings = settings
    },

    /* Subscription mutations */

    setSubscriptions (state, subscriptions) {
      state.subscriptions = subscriptions
    },

    setPartnerSubscriptions (state, { partner, subscriptions }) {
      var idx = state.partners.findIndex(p => p.id === partner.id)
      Vue.set(state.partners, idx, { ...partner, subscriptions })
    },
    removePartnerSubscription (state, { partner, subscription }) {
      var idx = state.partners.findIndex(p => p.id === partner.id)
      var subscriptions = partner.subscriptions.filter(({ subscription_id }) => subscription_id != subscription.subscription_id)
      Vue.set(state.partners, idx, { ...partner, subscriptions })
    },

    setAccountSubscriptions (state, { account, subscriptions }) {
     // console.log('setAccountSubscriptions', account, subscriptions)
      var idx = state.accounts.findIndex(a => a.id === account.id)
      Vue.set(state.accounts, idx, { ...account, subscriptions })
    },
    removeAccountSubscription (state, { account, subscription }) {
      var idx = state.accounts.findIndex(a => a.id === account.id)
      var subscriptions = account.subscriptions.filter(({ subscription_id }) => subscription_id != subscription.subscription_id)
      Vue.set(state.accounts, idx, { ...account, subscriptions })
    },

    //Partners
    setPartners (state, partners) {
      state.partners = partners
    },
    removePartner (state, partner) {
      var idx = state.partners.findIndex(p => p.id === partner.id)
      if (idx >= 0) state.partners.splice(idx, 1)
    },
    // Profiles
    setProfiles (state, profiles) {
      //console.log('setProfiles', profiles)
      state.profiles = profiles
    },
    setProfile (state, profile) {
      // console.log('setProfile', profile)
      sessionStorage.setItem('selectedProfileID', profile.id)
      state.profile = profile
    },
    addProfile (state, profile) {
      // console.log('addProfile', profile)
      state.profiles.push(profile)
    },
    removeProfile (state, profile) {
      // console.log('removeProfile', profile)
      var idx = state.profiles.findIndex(p => p.id === profile.id)
      if (idx >= 0) state.profiles.splice(idx, 1)
      if (state.profile.id == profile.id) {
        state.profile = {}
      }
    },
    // Exposure
    setExposure (state, exposure) {
      // console.log('setExposure', exposure)
      state.exposure = exposure
    },
    // Remediation
    setRemediation (state, remediation) {
      // console.log('setRemediation', remediation)
      state.remediation = remediation
    },
    setRemediationLog (state, remediationLog) {
      state.remediationLog = remediationLog
    },
    addRemediation (state, remediation) {
      //console.log(state) 
      state.remediationLog.push(remediation)
      for(var i=0;i<state.remediation.remediations.length;i++) {
        if(state.remediation.remediations[i].alert_ids == remediation.alert_ids) {
          state.remediation.remediations.splice(i,1)
        }
      }
      
    },
    deleteRemediation (state, remediation) {
      // console.log('deleteRemediation', remediation)
      //Set remediation to NULL so that it will not show
      remediation.id = null      
      remediation.username = null
      state.remediation.remediations.push(remediation)
      for(var i=0;i<state.remediationLog.length;i++) {
        if(state.remediationLog[i].alert_ids == remediation.alert_ids) {
          state.remediationLog.splice(i,1)
        }
      }
      //loadRemediation();
      
    },
    // Keywords
    setKeywords (state, keywords) {
      // console.log('setKeywords', keywords)
      for (var keyword in keywords) {
        keywords[keyword].selected = false
      }
      state.keywords = keywords
    },
    addKeywords (state, keywords) {
      // console.log('addKeywords', keywords)
      for (var keyword in keywords) {
        keywords[keyword].selected = false
        state.keywords.push(keywords[keyword])
      }
    },
    removeKeyword (state, keyword) {
      // console.log('removeKeyword', keyword)
      var idx = state.keywords.findIndex(k => k.id === keyword.id)
      if (idx >= 0) state.keywords.splice(idx, 1)
    },
    // Alerts
    setAlerts (state, alerts) {
      // console.log('setAlerts', alerts)
      state.alerts = alerts
    },
    setAlertsTotal (state, total) {
      // console.log('setAlertsTotal', total)
      state.alertsTotal = total
    },
    addAlerts (state, alerts) {
      // console.log('addAlerts', alerts)
      for (var i in alerts) {
        state.alerts.push(alerts[i])
      }
    },
    setAlertsStats (state, stats) {
      // console.log('setAlertsStats', stats)
      state.alertsStats = stats
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    }
  },
  
  /*
  Actions
  */
  actions: {
    setAccessToken ({ commit }, accessToken) {
      // console.log('SetAccessToken', accessToken)
      // commit('initState')
      commit('setAuthAccessToken', accessToken)
      // dispatch('loadPartners')
      return
    },
    setMode ({ commit, dispatch }, mode) {
      // console.log('SetMode', mode)
      if (mode === 'admin') {
        commit('setAdminMode')
        commit('initState')
        dispatch('loadPartners')
        dispatch('loadSubscriptions')
      } else if (mode === 'partner') {
        commit('setPartnerMode')
        commit('initState')
        dispatch('loadPartner')
        dispatch('loadAccounts')
        dispatch('loadSubscriptions')
      } else if (mode === 'account') {
        commit('setAccountMode')
        commit('initState')
        dispatch('loadAccount')
      }
    },
   /* loadPartners ({ state, commit }) {
      // console.log('loadPartners')
      state.apiAuth.get('/partners')
        .then(partners => {
          // console.log('Loaded partner', response)
          commit('setPartners', response.partners)
        })
    },*/
    loadPartner ({ state, commit }) {
      // console.log('loadPartner')
      state.apiAuth.get('/partner')
        .then(partner => {
          // console.log('Loaded partner', response)
          commit('setPartner', partner)
        })
    },
    /*loadSettings ({ state, commit }) {
      // console.log('loadPartnerSettings')
      state.apiAuth.get('/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setSettings', settings)
        })
    },*/
    loadPartners ({ state, commit, getters, dispatch }) {
      state.apiAuth.get('/partners')
        .then(response => {
          // console.log('Loaded partners', response)
          commit('setPartners', response.partners)
          // Select init partner or default
          var partner = getters.getPartnerById(initSelectedPartnerID)
          if (partner) {
            dispatch('selectPartner', partner)
          } else {
            dispatch('selectPartner', state.partners[0])
          }
        })
    },
    selectPartner ({ commit, dispatch }, partner) {
      // console.log('selectPartner', partner)
      commit('initStatePartner')
      commit('setPartner', partner)
      dispatch('loadAccounts')
      // dispatch('loadProfiles')
    },
    createPartner ({ state, commit }, params) {
      // console.log('createPartner', params)
      state.apiAuth.post('/partners', params)
        .then(partner => {
          commit('addPartner', partner)
        })
        .catch( error => {
          // console.log(error)
          alert(error.response.data.message)
        })
    },
    updatePartner ({ state }, { partner, params}) {
      // console.log('updatePartner', partner, params)
      params['partner_id'] = partner.id // Fix to get API call work as api.js tries to use selected partner
      state.apiAuth.put('/partners/' + partner.id, params, false)
        .then(updatedPartner => {
          // console.log(updatedPartner)
          Object.assign(partner, updatedPartner)
        })
        .catch( () => {
          alert('Failed to update partner')
        })
    },
    deletePartner ({ state, commit }, partner) {
      // console.log('deletePartner', partner)
      var params = {}
      params['partner_id'] = partner.id // Fix to get API call work as api.js tries to use selected partner
      state.apiAuth.delete('/partners/' + partner.id, params, false)
        .then( () => {
          commit('removePartner', partner)
      })
    },

    loadAccounts ({ state, commit, getters, dispatch }) {
      // console.log('loadAccounts')
      state.apiAuth.get('/accounts', null, false)
        .then(response => {
          // console.log('Loaded accounts', response)
          commit('setAccounts', response.accounts)
          // Select init account or default
          var account = getters.getAccountById(initSelectedAccountID)
          if (account) {
            dispatch('selectAccount', account)
          } else {
            dispatch('selectAccount', state.accounts[0])
          }
        })
    },
    loadAccount ({ state, commit, dispatch }) {
      // console.log('loadAccount')
      state.apiAuth.get('/account')
        .then(account => {
          // console.log('Loaded account', account)
          commit('setAccounts', [account])
          dispatch('selectAccount', account)
        })
    },
   /* loadAccountSettings ({ state, commit }) {
      // console.log('loadAccountSettings')
      state.apiAuth.get('/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setSettings', settings)
        })
    },*/

    selectAccount ({ commit, getters, dispatch }, account) {
      // console.log('selectAccount', account)
      if (!account) {

        // eslint-disable-next-line no-console
        console.warn('Trying to initialize undefined account')
        return
      }
      commit('initStateAccount')
      commit('setAccount', account)
      commit('setProfiles', account.profiles)
      dispatch('selectProfile', getters.getDefaultProfile())
      // dispatch('loadProfiles')
    },
    createAccount ({ state, commit }, params) {

      state.apiAuth.post('/accounts', params, false).then(account => {
          commit('addAccount', account)
        }).catch( error => {
          // console.log(error)
          alert(error.response.data.message)
        })
    },
    updateAccount ({ state }, { account, params}) {
      // console.log('updateAccount', account, params)
      state.apiAuth.put('/accounts/' + account.id, params).then(updatedAccount => {
          Object.assign(account, updatedAccount)
        }).catch( () => {
          // console.log(error)
          alert('Failed to update account')
        })
    },
    deleteAccount ({ state, commit }, account) {
      // console.log('deleteAccount', account)
      state.apiAuth.delete('/accounts/' + account.id).then( () => {
          commit('removeAccount', account)
        })
    },
    saveAccount ({ state, commit }) {
      // console.log('saveAccount')
      state.apiAuth.put('/account', {
        name: state.account.name,
        sector: state.account.sector,
        employees: state.account.employees
      }).then(account => {
          commit('setAccount', account)
      })
    },


    /*
      Subscription actions
    */

    loadSubscriptions ({ state, commit }) {
      // console.log('loadSubscriptions')
      state.apiAuth.get('/subscriptions').then(response => {
          commit('setSubscriptions', response.subscriptions)
        }).catch( () => {
          alert('Failed to load subscriptions')
        })
    },

    addPartnerSubscription ({ state, commit }, { partner, subscription }) {
      // console.log('addPartnerSubscription', partner, subscription)
      var params = { subscription_id: subscription.id }
      params['partner_id'] = partner.id // Fix to get API call work as api.js tries to use selected partner
      state.apiAuth.post('/partners/' + partner.id + '/subscriptions', params, false)
        .then(response => {
          commit('setPartnerSubscriptions', { partner, subscriptions: response.subscriptions })
        }).catch( () => {
          alert('Failed to add subscription')
        })
    },
    updatePartnerSubscription ({ state, commit }, { partner, subscription, params }) {
      // console.log('updatePartnerSubscription', account, subscription, params)
      params['partner_id'] = partner.id // Fix to get API call work as api.js tries to use selected partner
      state.apiAuth.put('/partners/' + partner.id + '/subscriptions/' + subscription.subscription_id, params, false)
        .then(response => {
          commit('setPartnerSubscriptions', { partner, subscriptions: response.subscriptions })
        })
        .catch( () => {
          alert('Failed to update subscription')
        })
    },
    removePartnerSubscription ({state, commit}, { partner, subscription } ) {
      // console.log('removeAccountSubscription', account, subscription)
      var params = {partner_id: partner.id} // Fix to get API call work as api.js tries to use selected partner
      state.apiAuth.delete('/partners/' + partner.id + '/subscriptions/' + subscription.subscription_id, params, false)
        .then(() => {
          commit('removePartnerSubscription', { partner: partner, subscription: subscription })
        })
        .catch( () => {
          alert('Failed to remove subscription')
        })
    },

    addAccountSubscription ({ state, commit }, { account, subscription }) {
      // console.log('addAccountSubscription', account, subscription)
      state.apiAuth.post('/accounts/' + account.id + '/subscriptions', { subscription_id: subscription.id })
        .then(response => {
          commit('setAccountSubscriptions', { account: account, subscriptions: response.subscriptions })
        }).catch( () => {
          alert('Failed to add subscription')
        })
    },
    updateAccountSubscription ({ state, commit }, { account, subscription, params }) {
      // console.log('updateAccountSubscription', account, subscription, params)
      state.apiAuth.put('/accounts/' + account.id + '/subscriptions/' + subscription.subscription_id, params)
        .then(response => {
        //  console.log(response)
          commit('setAccountSubscriptions', { account: account, subscriptions: response.subscriptions })
        })
        .catch( () => {
          alert('Failed to update subscription')
        })
    },
    removeAccountSubscription ({state, commit}, { account, subscription } ) {
      // console.log('removeAccountSubscription', account, subscription)
      state.apiAuth.delete('/accounts/' + account.id + '/subscriptions/' + subscription.subscription_id)
        .then(() => {
          commit('removeAccountSubscription', { account: account, subscription: subscription })
        }).catch( () => {
          alert('Failed to remove subscription')
        })
    },


    /*
      Settings actions
    */

    loadSettings ({ state, commit}) {
      // console.log('loadSettings')
      state.apiAuth.get('/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setSettings', settings)
        })
    },
    loadPartnerSettings ({ state, commit}) {
      // console.log('loadPartnerSettings')
      state.apiAuth.get('/partner/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setPartnerSettings', settings)
        })
    },
    loadAccountSettings ({ state, commit}) {
      // console.log('loadAccountSettings')
      state.apiAuth.get('/account/settings')
        .then(settings => {
          // console.log('Loaded settings', settings)
          commit('setAccountSettings', settings)
        })
    },
    saveSettings ({ state, commit }, params) {
      // console.log('Save settings', params)
      state.apiAuth.put('/settings', params).then(settings => {
        commit('setSettings', settings)
      }).catch( () => {
          // console.log(error)
          alert('Failed to save settings')
        })
    },
    savePartnerSettings ({ state, commit }, params ) {
      // console.log('Save partner settings', params)
      state.apiAuth.put('/partner/settings', params).then(settings => {
        commit('setPartnerSettings', settings)
      }).catch( () => {
          // console.log(error)
          alert('Failed to save settings')
        })
    },
    saveAccountSettings ({ state, commit }, params ) {
      // console.log('Save account settings', params)
      state.apiAuth.put('/account/settings', params).then(settings => {
        commit('setAccountSettings', settings)
      }).catch( () => {
          // console.log(error)
          alert('Failed to save settings')
        })
    },
    // saveAccountSettings ({ commit }, { account, params }) {
    //   // console.log('Save account settings', account, params)
    //   let api = new Api(apiUrl, account.api_keys[0].key)
    //   api.put('/settings', params).then(settings => {
    //     // console.log('Saved settings', settings)
    //     // commit('setAccountSettings', settings)
    //     account.settings = settings
    //   }).catch( () => {
    //       // console.log(error)
    //       alert('Failed to save settings')
    //     })
    // },

    /*
    Profiles
    */
    loadProfiles ({ state, commit, getters, dispatch }) {
      // console.log('loadProfiles')
      state.apiAuth.get('/profiles')
        .then(response => {
          // console.log('Loaded profiles', response)
          commit('setProfiles', response.profiles)
          // Select init profile or default
          var profile = getters.getProfileById(initSelectedProfileID)
          if (profile) {
            dispatch('selectProfile', profile)
          } else {
            commit('setProfile', getters.getDefaultProfile())
          }
        })
    },
    selectProfile ({ commit }, profile) {
      // console.log('selectProfile', profile)
      commit('initStateProfile')
      commit('setProfile', profile)
    },
    createProfile ({ state, commit }, params) {
      // console.log('createProfile', params)
      state.apiAuth.post('/profiles', params).then(profile => {
          commit('addProfile', profile)
        })
    },
    updateProfile ({ state }, { profile, params}) {
      // console.log('updateProfile', profile, params)
      state.apiAuth.put('/profiles/' + profile.id, params).then(updatedProfile => {
          // commit('addProfile', profile)
          profile.name = updatedProfile.name
        }).catch( () => {
          // console.log(error)
          alert('Failed to update profile')
        })
    },
    deleteProfile ({ state, commit }, profile) {
      // console.log('deleteProfile', profile)
      state.apiAuth.delete('/profiles/' + profile.id).then( () => {
          commit('removeProfile', profile)
        })
    },

    /*
    Exposure
    */
    loadExposure ({ state, commit }) {
      // console.log('loadExposure')
      // Clear exposure
      commit('setExposure', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAuth.get('/exposure', params)
        .then(exposure => {
          commit('setExposure', exposure)
        })
    },

    /*
    Remediation
    */
    loadRemediation ({ state, commit }) {
      // console.log('loadRemediation')
      // Clear remediation
      commit('setRemediation', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAuth.get('/remediation', params)
        .then(response => {
          // console.log(response)
          commit('setRemediation', response)
        })
    },

    loadRemediationLog ({ state, commit }) {
      // console.log('loadRemediationLog')
      // Clear remediation
      commit('setRemediationLog', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAuth.get('/remediation/log', params)
        .then(response => {
          // console.log(response)
          commit('setRemediationLog', response.remediations)
        })
    },
    createRemediation ({ state ,commit}, { remediation, params}) {
      state.apiAuth.post('/remediation', params).then(RespRemediation => {
        RespRemediation.alert_ids = remediation.alert_ids
        commit('addRemediation', RespRemediation)
      })            
    },
    removeRemediation ({ state ,commit},  remediation) {   
      // console.log('Delete', remediation)
      state.apiAuth.delete('/remediation/'+remediation.id).then( () => {
        commit('deleteRemediation', remediation)
      })      
    },

    /* 
    Keywords 
    */
    loadKeywords ({ state, commit }) {
      // console.log('loadKeywords')
      // Clear keywords
      commit('setKeywords', [])
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      state.apiAuth.get('/keywords', params)
        .then(keywords => {
          commit('setKeywords', keywords.keywords)
        })
    },
    updateKeywords ({ state, commit}, params) {
      if (state.profile) params['profile_id'] = state.profile.id
      params['start_update'] = false
      state.apiAuth.put('/keywords', params)
        .then( response => {
          commit('setKeywords', response.keywords)
        })
    },
    deleteKeywords ({ state, commit}) {
      var url = '/keywords'
      if (state.profile) url += '?profile_id=' + state.profile.id
      state.apiAuth.delete(url)
        .then( keywords => {
          commit('setKeywords', keywords)
        })
    },
    createKeyword ({ state, commit }, params) {
      // console.log('createKeyword', params)
      if (state.profile) params['profile_id'] = state.profile.id
      params['start_update'] = false
      state.apiAuth.post('/keywords', params)
        .then(keywords => {
          commit('addKeywords', keywords)
        })
        .catch(error => {
        if (error.response.status === 409) {
          alert('Keyword already exists')
        }
        return {}
      })
    },
    updateKeyword ({ state }, keyword) {
      // console.log('updateKeyword', keyword)
      state.apiAuth.post('/keywords/' + keyword.id + '/update', {
        force_update: true
      })
    },
    resetKeyword ({ state }, keyword) {
      // console.log('resetKeyword', keyword)
      state.apiAuth.post('/keywords/' + keyword.id + '/reset')
    },
    deleteKeyword ({ state, commit}, keyword) {
      // console.log('deleteKeyword', keyword)
      state.apiAuth.delete('/keywords/' + keyword.id)
        .then( () => {
          commit('removeKeyword', keyword)
        })
    },

    /*
    Alerts
    */
    loadAlertsStats ({ state, commit }, falsePositive) {
      // console.log('loadAlertStats', falsePositive)
      // Clear stats
      commit('setAlerts', [])
      commit('setAlertsTotal', 0)
      commit('setAlertsStats', {})
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      if (falsePositive) params['false_positive'] = true
      state.apiAuth.get('/alerts/stats', params)
        .then(stats => {
          commit('setAlertsStats', stats)
        })
    },
    loadAlerts ({ state, commit }, filters) {
      // console.log('loadAlerts', filters)
      // Clear alerts
      if (filters.page === 1) {
        commit('setAlerts', [])
        commit('setAlertsTotal', 0)
      }
      // Get from API
      var params = {}
      if (state.profile) params['profile_id'] = state.profile.id
      if (filters) {
        // Page
        if (filters.page) params['page'] = filters.page
        // False positive
        if (filters.falsePositive) params['false_positive'] = true
        // Time
        if (filters.after) params['after'] = filters.after
        if (filters.before) params['before'] = filters.before
        // Tags
        params['filter'] = filters.tags.join()
        params['filter_databreach'] = filters.breaches.join(';')
      }
      state.alertsLoading = true
      state.apiAuth.get('/alerts', params)
        .then( response => {
          commit('addAlerts', response.alerts)
          commit('setAlertsTotal', response.total)
          state.alertsLoading = false
        })
    },
    exportAlerts ( {state, commit}, params ) {
      if (state.profile) params['profile_id'] = state.profile.id
      var filename = state.account.name + '_' + state.profile.name + '_alerts.xlsx'
      commit('setExporting', true)
      state.apiAuth.download('/alerts/export' , params, filename).then( () => {
        commit('setExporting', false)
      })
      // state.apiAuth.get('/alerts', params)
      //   .then( response => {
      //     state.alertsLoading = false
      //   })
    },
    updateAlert ({ state, getters }, {alert, severity, category, password, password_type, snippets, comment}) {
      // console.log('updateAlert', params)
      var params = {}
      if (severity) params['severity'] = severity
      if (category) params['category'] = category
      if (password) params['password'] = password
      if (password_type) params['password_type'] = password_type
      if (snippets) params['snippets'] = snippets.join(';')
      if (comment) params['comment'] = comment
      state.apiAuth.put('/alerts/' + alert.id, params)
        .then( updatedAlert => {
          Object.assign(getters.getAlertById(alert.id), updatedAlert)
        })
    },
    addAlertTag ({ state }, {alert, tag}) {
      // console.log('addAlertTag', alert, tag)
      state.apiAuth.post('/alerts/' + alert.id + '/tags', {tag: tag})
        .then(updatedAlert => {
          alert.tags = updatedAlert.tags
        })
    },
    removeAlertTag ({ state }, {alert, tag}) {
      // console.log('removeAlertTag', alert, tag)
      state.apiAuth.delete('/alerts/' + alert.id + '/tags/' + tag)
        .then(updatedAlert => {
          alert.tags = updatedAlert.tags
        })
    },
    setUserInfo ({ commit }, userInfo){
      commit('setUserInfo', userInfo)
    }
  }
})
